import React from "react";
import PropTypes from "prop-types";

export const Twitter = ({ color = "#1CB7EB" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M14.7922 2.5H17.3491L11.7645 8.88128L18.3341 17.5659H13.1915L9.1606 12.3001L4.55391 17.5659H1.99343L7.96547 10.7392L1.66748 2.5H6.94055L10.5803 7.31312L14.7922 2.5ZM13.894 16.0376H15.3101L6.16915 3.94864H4.64807L13.894 16.0376Z"
        fill="white"
      />
    </svg>
  );
};
Twitter.propTypes = {
  color: PropTypes.string,
};
